/**
 * Logic for shouldShowQuickAddToCart follow implementation in AEM for addQuickAddToCartCTA, it checks 3 conditions:
 * 1. Must be a Simple product
 * 2. Must be a stick product (subscription_format === 'pack')
 * 3. Must be in stock
 */
export const shouldShowQuickAddToCart = (
  product: Record<string, unknown> | null | undefined,
  isEnabled: boolean
): boolean => {
  if (!isEnabled || !product) {
    return false;
  }

  if (product.isFreeTrialProduct === true) {
    return false;
  }

  if (product.type !== "SimpleProduct") {
    return false;
  }

  const subscriptionFormat = product.subscriptionFormat;
  if (typeof subscriptionFormat !== "string" || subscriptionFormat.toLowerCase() !== "pack") {
    return false;
  }

  return product.stockStatus === "IN_STOCK";
};
